<template>
  <Bubble
    :id="chartId"
    :options="options"
    :data="chartData"
    :styles="styles"
    :plugins="plugins"
  />
</template>

<script>
import { Bubble } from 'vue-chartjs';
import {
  Chart as ChartJS, Title, Tooltip, Legend, PointElement, CategoryScale, LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, PointElement, CategoryScale, LinearScale);

export default {
  name: 'BubbleChart',
  components: {
    Bubble,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    chartId: {
      type: String,
      required: true,
    },
    styles: {
      type: Object,
      default() {
        return {
          position: 'relative',
          width: '100%',
          height: '100%',
        };
      },
    },
    plugins: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
